import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  const names = ['María', 'Juan', 'Carla', 'Pedro', 'Sofía', 'Martín', 'Valentina', 'Lucas', 'Camila', 'Nicolás', 'Florencia', 'Matías', 'Agustina', 'Tomás', 'Rocío'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
  const getRandomPurchase = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    return {
      name: randomName,
      city: randomCity
    };
  };
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(getRandomPurchase());
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 3000);
    // Recurring interval (5-8 seconds)
    const interval = setInterval(() => {
      const randomDelay = 5000 + Math.random() * 3000;
      setTimeout(showPopup, randomDelay);
    }, 9000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-157">
      {isVisible && <motion.div initial={{
      x: -400,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -400,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-158">
          <div className="bg-white rounded-lg shadow-2xl p-4 flex items-center gap-4 border-2 border-[#D4A843]" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/pFqBHT4UTtFQHM8RGSUctk/MOCKUP.png" alt="Producto" className="w-16 h-16 object-cover rounded" data-id="element-160" />
            <div className="flex-1" data-id="element-161">
              <p className="text-sm font-semibold text-gray-900" data-id="element-162">
                {currentPurchase.name} de {currentPurchase.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-163">
                acaba de adquirir este libro digital
              </p>
            </div>
            <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-164">
              <XIcon className="w-5 h-5" data-id="element-165" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}